<div class="min-h-screen px-5 pt-2 pb-page-bottom">
  @if (!errorMessage) {
    <h1 class="font-accent text-2xl font-bold text-neutral-800">
      {{ 'pay-at-table.choose-amount.title' | translate }}
    </h1>
    <div class="py-5">
      <div class="flex flex-col gap-1">
        <app-input-multi-atom
          [type]="'radio'"
          [value]="amountTypeValues.Total"
          [id]="amountTypeValues.Total"
          [label]="'pay-at-table.choose-amount.pay-total-amount' | translate"
          [boldLabel]="true"
          [active]="radioButtons.total"
          (valueEmitter)="getAmountType($event)"
        >
          @if (radioButtons.total) {
            <p class="ml-8 mt-2 text-sm text-neutral-600">
              {{ 'pay-at-table.choose-amount.amount' | translate }} :
              <app-price-atom
                [amount]="(outstandingAmount$ | async) || 0"
                [format]="true"
                [bold]="false"
              ></app-price-atom>
            </p>
          }
        </app-input-multi-atom>
      </div>
      <div class="py-3.5">
        <app-input-multi-atom
          [type]="'radio'"
          [value]="amountTypeValues.Products"
          [id]="amountTypeValues.Products"
          [label]="'pay-at-table.choose-amount.choose-products-to-pay' | translate"
          [boldLabel]="true"
          [active]="radioButtons.products"
          (valueEmitter)="getAmountType($event)"
        >
          @if (radioButtons.products) {
            <div>
              <p class="ml-8 mt-2 text-sm text-neutral-600">
                {{ 'pay-at-table.choose-amount.amount' | translate }} :
                <app-price-atom
                  [amount]="selectedChooseType.totalAmount"
                  [format]="true"
                  [bold]="false"
                ></app-price-atom>
              </p>
              <p
                class="cursor-pointer ml-8 mt-1 text-sm font-bold text-primary-600"
                (click)="$event.stopPropagation(); openModal(amountTypeValues.Products)"
              >
                {{ 'pay-at-table.choose-amount.modify' | translate }}
              </p>
            </div>
          }
        </app-input-multi-atom>
      </div>
      <div class="py-3.5">
        <app-input-multi-atom
          [type]="'radio'"
          [value]="amountTypeValues.Divide"
          [id]="amountTypeValues.Divide"
          [label]="'pay-at-table.choose-amount.divide-bill' | translate"
          [boldLabel]="true"
          [active]="radioButtons.divide"
          (valueEmitter)="getAmountType($event)"
        >
          @if (radioButtons.divide) {
            <div>
              <p class="ml-8 mt-2 text-sm text-neutral-600">
                {{ 'pay-at-table.choose-amount.amount' | translate }} :
                <app-price-atom
                  [amount]="selectedChooseType.totalAmount"
                  [format]="true"
                  [bold]="false"
                ></app-price-atom>
              </p>
              <p
                class="cursor-pointer ml-8 mt-1 text-sm font-bold text-primary-600"
                (click)="$event.stopPropagation(); openModal(amountTypeValues.Divide)"
              >
                {{ 'pay-at-table.choose-amount.modify' | translate }}
              </p>
            </div>
          }
        </app-input-multi-atom>
      </div>
      <div class="py-3.5">
        <app-input-multi-atom
          [type]="'radio'"
          [value]="amountTypeValues.Free"
          [id]="amountTypeValues.Free"
          [label]="'pay-at-table.choose-amount.pay-free-amount' | translate"
          [boldLabel]="true"
          [active]="radioButtons.free"
          (valueEmitter)="getAmountType($event)"
        >
          @if (radioButtons.free) {
            <div>
              <p class="ml-8 mt-2 text-sm text-neutral-600">
                {{ 'pay-at-table.choose-amount.amount' | translate }} :
                <app-price-atom
                  [amount]="selectedChooseType.totalAmount"
                  [format]="true"
                  [bold]="false"
                ></app-price-atom>
              </p>
              <p
                class="cursor-pointer ml-8 mt-1 text-sm font-bold text-primary-600"
                (click)="$event.stopPropagation(); openModal(amountTypeValues.Free)"
              >
                {{ 'pay-at-table.choose-amount.modify' | translate }}
              </p>
            </div>
          }
        </app-input-multi-atom>
      </div>
      @if (isTipsEnabled) {
        <div>
          <app-cart-tip-atom
            [choice1Amount]="tipAmountsWithDefaults().choice1Amount"
            [choice1Unit]="tipAmountsWithDefaults().choice1Unit"
            [choice2Amount]="tipAmountsWithDefaults().choice2Amount"
            [choice2Unit]="tipAmountsWithDefaults().choice2Unit"
            [choice3Amount]="tipAmountsWithDefaults().choice3Amount"
            [choice3Unit]="tipAmountsWithDefaults().choice3Unit"
            [totalAmount]="totalAmount()"
            [selectedTip]="((tip$ | async) ?? 0) / 100 || 0"
            [isOtherAmountModal]="false"
            (tipEmitter)="onSelectedTip($event)"
            (otherAmountEmitter)="onOtherTipAmount()"
          ></app-cart-tip-atom>
        </div>
      }
    </div>
    @if (!isTransactionError) {
      <app-pat-base-modal>
        <p class="mb-3 text-center font-base text-neutral-800">
          {{ 'pay-at-table.choose-amount.rest-to-pay' | translate }} :
          <app-price-atom
            [amount]="(outstandingAmount$ | async) || 0"
            [bold]="false"
            [format]="true"
          ></app-price-atom>
        </p>
        <app-button-atom
          class="mx-auto"
          [disabled]="isLoading"
          [iconUrl]="isLoading ? 'assets/images/spinner.svg' : ''"
          [label]="('pay-at-table.pay' | translate) + ' ' + ((totalAmountWithTip$ | async) || '')"
          [full]="true"
          (click)="goToPayment()"
        ></app-button-atom>
      </app-pat-base-modal>
    }
    @if (isTransactionError) {
      <app-pat-base-modal>
        <p class="mb-3 text-center font-base text-neutral-800">
          {{ 'pay-at-table.choose-amount.error-occured' | translate }}
        </p>
        <app-button-atom
          class="mx-auto"
          [disabled]="isLoading"
          [iconUrl]="isLoading ? 'assets/images/spinner.svg' : ''"
          [label]="('pay-at-table.pay' | translate) + ' ' + ((totalAmountWithTip$ | async) || '')"
          [full]="true"
          (click)="goToPayment()"
        ></app-button-atom>
      </app-pat-base-modal>
    }
    @if (isModalTipOtherAmountOpen && isTipsEnabled) {
      <app-pat-base-modal
        [blur]="true"
        (closeModal)="closeTipModal()"
      >
        <app-input-tip-picker-atom
          (applyTip)="onApplyTip($event)"
          (closeTip)="closeTipModal()"
        ></app-input-tip-picker-atom>
      </app-pat-base-modal>
    }
  }
  @if (errorMessage) {
    <app-pat-checks-error
      [error]="errorMessage"
      [displayRetryButton]="true"
    ></app-pat-checks-error>
  }
</div>
